class CornerRealisation {
  expertise: Element | null;
  marche: Element | null;
  solution: Element | null;
  constructor() {
    this.expertise = document.querySelector('#expertise');
    this.marche = document.querySelector('#marche');
    this.solution = document.querySelector('#solution');
    if (this.expertise || this.marche || this.solution) {
      this._init();
    }
  }

  _init() {
    if (this.expertise) {
      this.expertise?.addEventListener('change', (e: any) => {
        this.changeSelect();
      });
    }
    if (this.marche) {
      this.marche?.addEventListener('change', (e: any) => {
        this.changeSelect();
      });
    }
    if (this.solution) {
      this.solution?.addEventListener('change', (e: any) => {
        this.changeSelect();
      });
    }
  }

  changeSelect(): void {
    let expertise: any = document.querySelector('#expertise');
    let marche: any = document.querySelector('#marche');
    let solution: any = document.querySelector('#solution');

    expertise = expertise ? expertise.value : '';
    marche = marche ? marche.value : '';
    solution = solution ? solution.value : '';
    // Construire l'URL avec les valeurs sélectionnées
    const url =
      document.location.origin +
      document.location.pathname +
      `?expertise=${encodeURIComponent(expertise)}&marche=${encodeURIComponent(
        marche
      )}&solution=${encodeURIComponent(solution)}#realisation`;

    // Rediriger vers l'URL avec les valeurs sélectionnées
    window.location.href = url;
  }
}
export const cornerRealisation = new CornerRealisation();
